export async function getContentPage(id) {
    const urlAPI = process.env.REACT_APP_URL_API_WP;
    //const urlAPI = 'http://wpkk.localhost/wp-json/wp/v2/';
    const urlEndpoint = urlAPI + 'pages/' + id;

    try {
        let apiStr = urlEndpoint;

        let response = await fetch(apiStr, {
            method: 'GET'
        });
        let responseJson = await response.json();
        if (responseJson !== null) {
            let apiReturn;
            if (responseJson !== true && 'error' in responseJson && responseJson.error.length > 0 ) {
                apiReturn =  responseJson.error;
            } else {
                apiReturn =  responseJson;
            }
            return apiReturn;
        }
    } catch (error) {
        console.log('SbC fetch error page: ', error.message);
    }
}

export async function getContentPages() {
    const urlAPI = process.env.REACT_APP_URL_API_WP;
    //const urlAPI = 'http://wpkk.localhost/wp-json/wp/v2/';
    const urlEndpoint = urlAPI + 'pages/';

    try {
        let apiStr = urlEndpoint;

        let response = await fetch(apiStr, {
            method: 'GET'
        });
        let responseJson = await response.json();
        if (responseJson !== null) {
            let apiReturn;
            if (responseJson !== true && 'error' in responseJson && responseJson.error.length > 0 ) {
                apiReturn =  responseJson.error;
            } else {
                apiReturn =  responseJson;
            }
            return apiReturn;
        }
    } catch (error) {
        console.log('SbC fetch error pages: ', error.message);
    }
}

export async function getCustomFields() {
    const id=32;
    const urlAPI = process.env.REACT_APP_URL_API_WP;
    const urlEndpoint = urlAPI + 'pages/' + id;

    try {
        let apiStr = urlEndpoint;

        let response = await fetch(apiStr, {
            method: 'GET'
        });
        let responseJson = await response.json();
        if (responseJson !== null) {
            let apiReturn;
            if (responseJson !== true && 'error' in responseJson && responseJson.error.length > 0 ) {
                apiReturn =  responseJson.error;
            } else {
                apiReturn =  responseJson;
            }
            return apiReturn;
        }
    } catch (error) {
        console.log('SbC fetch error custom fields: ', error.message);
    }
}
